// Antigravity (Gemini) nella finestra «Aggiungi provider» (tela, artboard 40 e 40b): si collega con l'account
// Google (PopTown dà l'indirizzo, la persona autorizza e incolla il codice di Google) oppure con
// una chiave API, che PopTown prova e non mostra più.
import { Field, TextField } from '../../components/Field';
import { Segmented } from '../../components/Segmented';
import type { PendingProvider } from '../../lib/api';

export type GeminiMode = 'google' | 'key';

export function GeminiChoice({
  mode,
  onMode,
  token,
  onToken,
}: {
  mode: GeminiMode;
  onMode: (m: GeminiMode) => void;
  token: string;
  onToken: (v: string) => void;
}) {
  return (
    <div style={{ display: 'grid', gap: 10 }}>
      <Segmented
        label="Come si collega Antigravity"
        value={mode}
        items={[
          { value: 'google', label: 'Account Google' },
          { value: 'key', label: 'Chiave API' },
        ]}
        onChange={onMode}
      />
      {mode === 'google' ? (
        <div className="t-small dim">
          Premi «Collega»: PopTown ti dà un indirizzo di Google. Accedi con l&apos;account che
          PopTown deve usare (con l&apos;abbonamento Google AI, se ce l&apos;hai), autorizza e
          incolla qui il codice che Google ti mostra.
        </div>
      ) : (
        <>
          <div className="t-small dim">
            La chiave si crea in Google AI Studio. PopTown la prova con una domanda breve e non la
            mostra più.
          </div>
          <Field label="Chiave API">
            <TextField
              type="password"
              value={token}
              onChange={onToken}
              placeholder="AIza…"
              autoComplete="off"
              mono
              autoFocus
            />
          </Field>
        </>
      )}
    </div>
  );
}

export function GooglePending({
  pending,
  code,
  onCode,
}: {
  pending: PendingProvider;
  code: string;
  onCode: (v: string) => void;
}) {
  return (
    <div style={{ display: 'grid', gap: 10 }}>
      <div className="t-body" style={{ fontWeight: 600 }}>
        Accedi con Google
      </div>
      <div className="t-small dim" style={{ overflowWrap: 'anywhere' }}>
        Apri{' '}
        <a href={pending.url} target="_blank" rel="noreferrer noopener">
          {pending.url.replace(/^https:\/\//, '').slice(0, 40)}…
        </a>
        , accedi con l&apos;account che PopTown deve usare e autorizza. Google ti mostra un codice:
        incollalo qui. Vale 5 minuti.
      </div>
      <Field label="Codice di Google">
        <TextField value={code} onChange={onCode} placeholder="4/0A…" mono autoFocus />
      </Field>
    </div>
  );
}
